<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.noticeManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                id="title"
                name="title"
                v-model="notice.title"
                class="int_type01"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.file") }}</th>
            <td>
              <uploader
                class="uploader-example"
                :autoStart="false"
                :size="10"
                @file-added="filesAdded"
                @file-removed="fileRemoved"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn>Select or drag&drop file</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
              <div class="view_file" v-if="files.length > 0 && files != null">
                <ul>
                  <li>
                    <a v-for="(file, index) in files" :key="index" href="#">
                      {{ file.fileNm }}
                      <button @click="deleteFile(file)" class="del_bt">Del</button>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                class="textarea_type"
                name="content"
                v-model="notice.content"
                :config="editorConfig"
                v-validate="'required'"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/notice"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="saveNotice" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { insertNotice } from "@/api/notice";
import { getNoticeMgmtDetail } from "@/api/notice";
import { deleteFile } from "@/api/file";

export default {
  data() {
    return {
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      notice: { noticeFiles: "", flag: "I" },
      files: [],
      newFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
      ],
    };
  },
  mounted() {
    if (this.$route.params.boardId != null) {
      this.fetchData();
    }
  },
  methods: {
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
    async fetchData() {
      try {
        this.boardId = this.$route.params.boardId;
        const response = await getNoticeMgmtDetail(this.boardId);
        this.notice = response.data.notice;
        this.notice.flag = "U";
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async saveNotice() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const formData = new FormData();
        formData.append("boardId", this.boardId);
        formData.append("flag", this.notice.flag);
        formData.append("title", this.notice.title);
        formData.append("content", this.notice.content);
        formData.append("lang", this.notice.lang);
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("noticeFiles", file);
          }
        }
        const { data } = await insertNotice(formData);
        if (data.fileMessage != null && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == null && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          if (this.notice.flag == "U") {
            this.$router.push({
              name: "mgmtNoticeView",
              query: { boardId: this.boardId },
            });
          } else {
            this.$router.push({ name: "mgmtNotice" });
          }
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteFile(file) {
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        const { data } = await deleteFile(file);
        if (data.status) {
          this.notice = "";
          this.files = [];
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPleasecontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
